/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentPromptSuggestionResponse {
    getFixupPrototypeFunction() { return AgentPromptSuggestionResponse.fixupPrototype; }

    static newInstance(model: Partial<AgentPromptSuggestionResponse>): AgentPromptSuggestionResponse {
        let obj = Object.assign(new AgentPromptSuggestionResponse(), model);
        AgentPromptSuggestionResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentPromptSuggestionResponse>): AgentPromptSuggestionResponse {
        if (!model) return null;
        return AgentPromptSuggestionResponse.newInstance(<AgentPromptSuggestionResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentPromptSuggestionResponse) {
        if (!obj) return;

        models.AgentPromptSuggestionResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentPromptSuggestionResponse): boolean {
        Object.setPrototypeOf(obj, AgentPromptSuggestionResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of suggested prompts
     */
    suggested_prompts: Array<string>;

}
